import { render, staticRenderFns } from "./industryHealthJournalDetailAppr.vue?vue&type=template&id=14f3ec94"
import script from "./industryHealthJournalDetailAppr.vue?vue&type=script&lang=js"
export * from "./industryHealthJournalDetailAppr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14f3ec94')) {
      api.createRecord('14f3ec94', component.options)
    } else {
      api.reload('14f3ec94', component.options)
    }
    module.hot.accept("./industryHealthJournalDetailAppr.vue?vue&type=template&id=14f3ec94", function () {
      api.rerender('14f3ec94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/appr/hea/ihj/industryHealthJournalDetailAppr.vue"
export default component.exports